<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-label slot="start" style="margin-right: 2vw">Khu trò chơi</ion-label>
        <ion-title>GimoSport</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="$router.replace('/account/gamescenter')">Đóng</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <template v-if="loaded">
        <iframe :src="app.loginUrl"
          name="restreamer-player" width="100%" height="100%" scrolling="no" frameborder="0"
          webkitallowfullscreen="false" mozallowfullscreen="false" allowfullscreen="false" class="frameHandle"></iframe>
        </template>
    </ion-content>
    <div class="balance">
        <div>Số dư điểm:</div>
        <div>{{ $utils.numberFormat(memberPoints) }} P</div>
    </div>
  </ion-page>
</template>

<style scoped>
  .frameHandle {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  .balance {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #333;
    color: #dedede;
    padding: 12px 20px;
  }

</style>

<script>
import { defineComponent } from 'vue'
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonLabel,
  IonContent,
} from '@ionic/vue'
import authService from '@/services/auth';

export default defineComponent({
  name: 'GamesCenter',
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonLabel,
    IonContent,
  },
  computed: {
    isLoggedIn() {
      return authService.user() && !authService.user().isAnonymous;
    },
    memberPoints() {
      if (!this.isLoggedIn)
        return 0;

      if (!this.$store.state.fsdb.customer)
        return 0;

      return this.$store.state.fsdb.customer.points;
    },
  },
  data() {
    return {
      loaded: false,
      app: null,
    };
  },
  mounted() {
    if (this.$route.query.payload) {
      console.log(this.$route.query.payload);
      this.app = JSON.parse(decodeURI(this.$route.query.payload));
      this.loaded = true;
    }
  },
  setup() {
    //
  },
})
</script>
